__turbopack_context__.v({
  "RandomBanner": "RandomBanners-module__NucXDq__RandomBanner",
  "RandomBanners": "RandomBanners-module__NucXDq__RandomBanners",
  "banner": "RandomBanners-module__NucXDq__banner",
  "bottom": "RandomBanners-module__NucXDq__bottom",
  "contents": "RandomBanners-module__NucXDq__contents",
  "left": "RandomBanners-module__NucXDq__left",
  "noScale": "RandomBanners-module__NucXDq__noScale",
  "right": "RandomBanners-module__NucXDq__right",
  "tall": "RandomBanners-module__NucXDq__tall",
  "titleContainer": "RandomBanners-module__NucXDq__titleContainer",
  "top": "RandomBanners-module__NucXDq__top",
});
